var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserChecked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1829_9051)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7712 8.68541C16.0237 8.87462 16.0751 9.23276 15.8859 9.48534L11.1773 15.7711C11.0865 15.8924 10.9512 15.9726 10.8011 15.9941C10.6511 16.0156 10.4987 15.9767 10.3774 15.8858L7.23455 13.5315C6.98196 13.3423 6.93059 12.9842 7.1198 12.7316C7.309 12.479 7.66715 12.4276 7.91973 12.6168L10.6052 14.6285L14.9712 8.80016C15.1604 8.54758 15.5186 8.4962 15.7712 8.68541Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.71427 1.14286C4.6097 1.14286 3.71427 2.03829 3.71427 3.14286C3.71427 4.24743 4.6097 5.14286 5.71427 5.14286C6.81884 5.14286 7.71427 4.24743 7.71427 3.14286C7.71427 2.03829 6.81884 1.14286 5.71427 1.14286ZM2.57141 3.14286C2.57141 1.40711 3.97852 0 5.71427 0C7.45002 0 8.85712 1.40711 8.85712 3.14286C8.85712 4.87861 7.45002 6.28571 5.71427 6.28571C3.97852 6.28571 2.57141 4.87861 2.57141 3.14286Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.60502 8.09205C5.71878 7.91599 4.80024 8.00652 3.96542 8.35219C3.13059 8.69786 2.41693 9.28317 1.91456 10.0342C1.41224 10.7852 1.1437 11.6681 1.14286 12.5716V13.7142H3.42857C3.74416 13.7142 4 13.97 4 14.2856C4 14.6012 3.74416 14.8571 3.42857 14.8571H0.571429C0.255837 14.8571 0 14.6012 0 14.2856V12.5713C0.000993411 11.4419 0.336669 10.3376 0.96463 9.39878C1.59259 8.45999 2.48467 7.72835 3.5282 7.29627C4.57173 6.86418 5.7199 6.75103 6.8277 6.9711C7.9355 7.19117 8.95325 7.7346 9.75238 8.53274C9.97568 8.75576 9.9759 9.11757 9.75288 9.34086C9.52987 9.56416 9.16806 9.56438 8.94476 9.34136C8.30545 8.70285 7.49126 8.26811 6.60502 8.09205Z",
    fill: "black",
    fillOpacity: 0.87
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1829_9051"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserChecked);
export default __webpack_public_path__ + "static/media/userChecked.2dbb887c435d7c9ea2f6d2bf61a0fa1f.svg";
export { ForwardRef as ReactComponent };